module.exports = __webpack_public_path__ + "static/image5-c1f3cf8d900767318b4edd79393127bb.jpg";